import { Modal, ModalOverlay, ModalContent, ModalBody } from '@chakra-ui/modal';
import Card from 'components/card';
import InputField from 'components/fields/InputField';
import { MdClose } from 'react-icons/md';
import { useState } from 'react';

const ApiKeyModal = (props: {
    isOpen: boolean;
    onClose: () => void;
    serviceName: string;
    onSave: (apiKey: string) => void;
    loading?: boolean;
}) => {
    const { isOpen, onClose, serviceName, onSave, loading } = props;
    const [apiKey, setApiKey] = useState('');

    const handleSave = () => {
        if (apiKey.trim()) {
            onSave(apiKey);
        }
    };

    const handleClose = () => {
        setApiKey('');
        onClose();
    };

    return (
        <div className="relative">
            <Modal isOpen={isOpen} onClose={handleClose} scrollBehavior="inside">
                <ModalOverlay className="bg-[#000] !opacity-30" />
                <ModalContent className="!z-[1002] !m-auto !w-max min-w-[350px] !max-w-[85%] border-none p-0 shadow-none focus:outline-none md:top-[12vh]">
                    <ModalBody>
                        <Card extra="px-[30px] pt-[35px] pb-[40px] max-w-[550px] flex flex-col !z-[1004]">
                            <div className="absolute right-5 top-5">
                                <MdClose
                                    size={20}
                                    className="cursor-pointer text-gray-600 hover:text-gray-800 dark:text-white"
                                    onClick={handleClose}
                                />
                            </div>
                            <h2 className="mb-4 text-2xl font-bold text-navy-700 dark:text-white">
                                Configurer {serviceName}
                            </h2>
                            <p className="mb-6 text-sm text-gray-600 dark:text-gray-400">
                                Veuillez entrer votre clé API {serviceName} pour
                                connecter votre compte.
                            </p>
                            <InputField
                                label="Clé API"
                                placeholder="Entrez votre clé API"
                                id="apiKey"
                                type="text"
                                defaultValue={apiKey}
                                onChange={(e: any) => setApiKey(e.target.value)}
                                extra="mb-6"
                            />
                            <div className="flex gap-3">
                                <button
                                    className="linear flex h-10 flex-1 items-center justify-center rounded-xl border-2 border-gray-300 px-5 py-3 text-sm font-medium text-gray-700 transition duration-200 hover:bg-gray-100 dark:border-gray-600 dark:text-white dark:hover:bg-gray-800"
                                    onClick={handleClose}
                                    disabled={loading}
                                >
                                    Annuler
                                </button>
                                <button
                                    className="linear flex h-10 flex-1 items-center justify-center rounded-xl bg-leadrs px-5 py-3 text-sm font-medium text-white transition duration-200 hover:bg-leadrsLight disabled:cursor-not-allowed disabled:opacity-50"
                                    onClick={handleSave}
                                    disabled={!apiKey.trim() || loading}
                                >
                                    {loading ? 'Enregistrement...' : 'Enregistrer'}
                                </button>
                            </div>
                        </Card>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </div>
    );
};

export default ApiKeyModal;
